module.exports = __webpack_public_path__ + "static/img/contacts.027a75b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/contacts.png
// module id = ZzYu
// module chunks = 1